import { inject } from "inversify-props";
import { ConfigService } from "./config/ConfigService";
import { HttpService } from "./HttpService";
import { Buffer } from "buffer";

export class JwtAuthService {
  @inject("ConfigService") configService: ConfigService;
  @inject("HttpService") httpService: HttpService;

  public isAuthenticated() {
    const token = localStorage.getItem("token");
    const JWS_REGEX = /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/;

    if (!token) {
      return false;
    }
    if (!JWS_REGEX.test(token)) {
      return false;
    }

    // Check whether the token is expired and return
    // true or false

    return !this.isJwtTokenExpired(token);
  }

  isJwtTokenExpired(token: string) {
    return this.isJwtTokenExpiringInMinutes(token, 0);
  }

  isJwtTokenExpiringInMinutes(token: string, minutes: number) {
    const decoded = this.decodeAs<{ exp: number }>(token);
    return Date.now() + minutes * 60 * 1000 >= decoded.exp * 1000;
  }

  decodeAs<T>(token: string) {
    const payloadBase64 = token.split(".")[1];
    const decodedJson = Buffer.from(payloadBase64, "base64").toString();
    const decoded = JSON.parse(decodedJson);
    return decoded as T;
  }

  public getToken() {
    return localStorage.getItem('token');
  }
}
